import { Divider, Grid, Stack } from '@mui/material';
import React from 'react';
import { useGet } from '../../lib/api/hooks';
import { useNotificationsDispatch } from '../../lib/contexts/NotificationsContext';
import { NotificationActionTypes } from '../../lib/contexts/NotificationsContext/actions';
import { NotificationPreferencesModel } from '../../lib/models/NotificationPreferencesModel';
import Card from '../Utils/Card';
import EmailNotification from './Notifications/EmailNotification';
import TextNotification from './Notifications/TextNotification';

const Notifications = () => {
    const { loading: notifLoading, data: notifData } = useGet<NotificationPreferencesModel>(
        'notifications/preferences'
    );

    const dispatch = useNotificationsDispatch();

    React.useEffect(() => {
        if (notifData) {
            dispatch({
                type: NotificationActionTypes.UpdateData,
                payload: notifData
            });
        }
    }, [dispatch, notifData]);

    return (
        <>
            {!notifLoading && notifData && (
                <Stack>
                    <Card.Title>Notifications</Card.Title>
                    <Card.SubTitle>
                        You will receive urgent cases if your notifications preferences are on or
                        off
                    </Card.SubTitle>
                    <Card sx={{ marginTop: 1 }}>
                        <Card.Body>
                            <Grid container rowSpacing={2} columnSpacing={8}>
                                <Grid item xs={12} md={6}>
                                    <EmailNotification />
                                </Grid>
                                <Grid item xs={12} display={{ md: 'none' }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextNotification />
                                </Grid>
                            </Grid>
                        </Card.Body>
                    </Card>
                </Stack>
            )}
        </>
    );
};

export default Notifications;
